var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:['cart-summary-row', _vm.borderTopClass]},[_c('td',{class:_vm.boldClass,attrs:{"colspan":_vm.colspanLeft}},[_vm._v(_vm._s(_vm.name))]),_c('td',{class:_vm.boldClass},[_vm._v(_vm._s(_vm.getValue))]),_c('td',{attrs:{"colspan":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }